import React from "react";
import "./Button.scss";
import { Button as MaterialButton } from "@mui/material";

const Button = (props) => {
  const className = props.className
    ? `${props.className} instream-button`
    : "instream-button";

  const handleClick = (e) => {
    props.onClick({
      target: null,
      value: e.target.value,
    });
  };

  const generateLabel = (label) => {
    if (label == null || label === "") {
      return;
    } else {
      return label;
    }
  };

  const variant = props.outlined ? "outlined" : "contained";
  const color = props.primary ? "primary" : "secondary";

  return (
    <MaterialButton
      {...props}
      disabled={props.disabled}
      className={className}
      onClick={handleClick}
      color={color}
      variant={variant}
    >
      {generateLabel(props.label)}
    </MaterialButton>
  );
};

export default Button;
